module.exports = __webpack_public_path__ + "static/Dona-Regular-a99a3c38dd366e9e950011dcbe885292.woff2";